module.exports = __webpack_public_path__ + "img/通知-底图.c2677bd4.png";